import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const ItemManagement = require('./ItemManagement.js').default;
const ItemManagementPage = () => _jsx(ItemManagement, {});
export default ItemManagementPage;
